import { GetCep } from "@/shared/domain/usecases/get-cep";
import { makeUtilDatasource } from "../datasources/util-datasource-factory";
export var makeGetCep = function () { return new GetCep(makeUtilDatasource()); };
